<template>
  <v-accordion-item :heading="$t(titleKey)">
    <InstallDependenciesForLanguage
      :lang="langExample.language"
      :dependencies="langExample.dependencies"
      :version="langExample.version"
    />
  </v-accordion-item>
</template>

<script lang="ts" setup>
import { LanguageExample } from '@bifrost-dev-docs-mfe/common/types/examples';
import { computed, PropType } from 'vue';
import { VAccordionItem } from '@vonage/vivid-vue';
import InstallDependenciesForLanguage from '@/components/example/language-specific/InstallDependenciesForLanguage.vue';

const props = defineProps({ langExample: { type: Object as PropType<LanguageExample>, required: true } });

const titleKey = computed(() =>
  props.langExample.dependencies?.some(dep => dep.toUpperCase() === 'JWT')
    ? 'examples.installDeps.generateYourJwt'
    : 'examples.installDeps.installDependencies'
);
</script>
